import {
  SanityBusinessLine,
  SanityInvestmentStrategies,
} from '../../types/generated/graphql-types'
import { InvestmentStrategiesProps } from '../components/blocks/InvestmentStrategies'
import { InvestmentStrategyItemProps } from '../components/InvestmentStrategyItem'
import { MetricValues } from '../components/KeyMetrics'
import { notEmpty } from '../utilities/filters'
import { Translations } from '../utilities/localization'
import { isNullOrWhiteSpace } from '../utilities/string'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const mapSanityBusinessLineToInvestmentStrategyItemProps = (
  businessLine: SanityBusinessLine,
  translations: Translations
): InvestmentStrategyItemProps => {
  const keyMetrics: MetricValues[] = []

  if (!isNullOrWhiteSpace(businessLine.currentInvestments)) {
    keyMetrics.push({
      metricTitle: !isNullOrWhiteSpace(businessLine.currentInvestmentsLabelOverride)
        ? (businessLine.currentInvestmentsLabelOverride as string)
        : translations.currentInvestments ?? '',
      metricValue: businessLine.currentInvestments as string,
    })
  }

  if (!isNullOrWhiteSpace(businessLine.investmentAdvisors)) {
    keyMetrics.push({
      metricTitle: !isNullOrWhiteSpace(businessLine.investmentAdvisorsLabelOverride)
        ? (businessLine.investmentAdvisorsLabelOverride as string)
        : translations.investmentAdvisors ?? '',
      metricValue: businessLine.investmentAdvisors as string,
    })
  }

  return {
    descriptionFormatted: businessLine?._rawArticlePreambleFormatted ?? undefined,
    investmentRangeLabelOverride: businessLine.investmentRangeLabelOverride ?? undefined,
    investmentRanges:
      businessLine.investmentRanges
        ?.filter(notEmpty)
        .map(range => range.value)
        ?.filter(notEmpty) ?? [],
    keyMetrics: keyMetrics,
    title: businessLine.title ?? '',
    link: businessLine.path?.length
      ? {
          url: businessLine.path,
          isExternal: false,
          title: translations.more ?? '',
        }
      : undefined,
  }
}

export const mapSanityInvestmentStrategiesToInvestmentStrategiesProps = (
  { gaTrackingId, items, title }: SanityInvestmentStrategies,
  translations: Translations
): InvestmentStrategiesProps => ({
  gaTrackingId: gaTrackingId ?? undefined,
  items:
    items?.filter(notEmpty).map(item => {
      const link = item.link ? mapSanityLinkToInternalExternalLink(item.link) : undefined

      return {
        descriptionFormatted: item._rawDescription ?? undefined,
        keyMetrics: item.keyMetrics?.filter(notEmpty).map(metric => ({
          metricTitle: metric.label ?? '',
          metricValue: metric.value ?? '',
        })),
        investmentRangeLabelOverride: item.subtitle ?? undefined,
        investmentRanges: item.investmentRanges?.filter(notEmpty),
        link: link ? { ...link, title: translations.more ?? '' } : undefined,
        title: link?.title ?? '',
      }
    }) ?? [],
  title: title ?? undefined,
})
